export const profileData = {
  name: "Soumajit Sharma",
  title: "Data Modeler & Engineer",
  tagline: "Architecting Data Pipelines. Engineering Intelligent Systems.",
  location: "Kolkata, India",
  email: "soumajitsharma.2506@gmail.com",
  phone: "+91-70597-88769",
  linkedin: "https://linkedin.com/in/soumajit-sharma-291849235",
  photo: "/profile.png",
  resumeUrl: "/Sharma_Soumajit_Resume_22032026.pdf",
  cvUrl: "/Sharma_Soumajit_CV_22032026.pdf",
  summary:
    "Data Modeler with 3+ years of experience in designing conceptual, logical, and physical data models using ER Studio. Hands-on experience in Snowflake-based data warehousing, dimensional modeling (star and snowflake schema), and DDL development. Strong understanding of data governance, metadata management, and enterprise data standards. Proven ability to collaborate with cross-functional teams to design scalable and optimized data solutions.",
  stats: [
    { label: "Years Experience", value: "3+" },
    { label: "Data Models Designed", value: "50+" },
    { label: "Schema Optimizations", value: "100+" },
    { label: "Team Collaborations", value: "20+" },
  ],
};

export const experienceData = [
  {
    id: 1,
    role: "Data Analyst",
    team: "Data Modelling POD",
    company: "Accenture",
    period: "2024 — Present",
    description: [
      "Improved query performance and reporting efficiency through optimized data model design.",
      "Designed and maintained conceptual, logical, and physical data models using ER Studio for enterprise data warehouse.",
      "Developed and optimized DDL scripts for tables and views in Snowflake.",
      "Implemented dimensional modeling techniques including star and snowflake schema.",
      "Managed metadata, lineage, and governance using Collibra.",
      "Collaborated with cross-functional teams to align data models with business requirements.",
    ],
    technologies: ["ER Studio", "Snowflake", "Collibra", "Star Schema", "DDL"],
  },
  {
    id: 2,
    role: "Associate",
    team: "Data Modelling POD",
    company: "Accenture",
    period: "2022 — 2024",
    description: [
      "Built foundational data models aligned with business domains.",
      "Supported DDL generation and validation for reporting layers.",
      "Ensured governance compliance including naming standards and data classification.",
      "Participated in peer reviews and maintained version control using Git integration.",
    ],
    technologies: ["DDL", "Git", "Data Governance", "Peer Reviews"],
  },
];

export const skillsData = {
  categories: [
    {
      name: "Data Modeling",
      icon: "Database",
      skills: [
        "Conceptual Modeling",
        "Logical Modeling",
        "Physical Modeling",
        "Star Schema",
        "Snowflake Schema",
        "Dimensional Modeling",
        "SCD Type 1 & 2",
      ],
    },
    {
      name: "SQL & Querying",
      icon: "Code",
      skills: ["Complex Joins", "CTEs", "Window Functions", "DDL Scripts", "Query Optimization"],
    },
    {
      name: "Databases & Platforms",
      icon: "Server",
      skills: ["Snowflake", "SQL Server", "MySQL"],
    },
    {
      name: "Tools & Governance",
      icon: "Settings",
      skills: ["ER Studio", "Collibra", "Ataccama", "DB Visualizer", "Git"],
    },
  ],
};

export const projectsData = [
  {
    id: 1,
    title: "Healthcare Data Warehouse",
    domain: "Healthcare Analytics",
    description:
      "Designed schema supporting reporting and analytics use cases, improving data accessibility and performance across the healthcare domain.",
    highlights: [
      "Designed fact and dimension tables for healthcare analytics",
      "Implemented SCD Type 2 for tracking historical data",
      "Developed data models in ER Studio and deployed structures in Snowflake",
      "Enabled reporting and analytics through optimized schema design",
    ],
    technologies: ["ER Studio", "Snowflake", "SCD Type 2", "Dimensional Modeling"],
  },
];

export const educationData = [
  {
    id: 1,
    degree: "MCA — Cloud Computing",
    institution: "Chandigarh University",
    location: "Punjab",
    period: "2025 — Present",
    status: "In Progress",
  },
  {
    id: 2,
    degree: "BSc Computer Science (Honours)",
    institution: "Calcutta University",
    location: "Kolkata",
    period: "2017 — 2020",
    status: "Completed",
  },
];

export const certificationsData = [
  {
    id: 1,
    name: "SnowPro Core Certification",
    issuer: "Snowflake",
    icon: "Snowflake",
  },
  {
    id: 2,
    name: "Neo4j Certified Professional",
    issuer: "Neo4j",
    icon: "CircuitBoard",
  },
];

export const awardsData = [
  {
    id: 1,
    name: "AI Productivity Catalyst Award",
    issuer: "Accenture",
  },
  {
    id: 2,
    name: "Shared Success Catalyst Award",
    issuer: "Accenture",
  },
];

export const languagesData = ["English", "Bengali", "Hindi"];

export const navLinks = [
  { label: "About", href: "#about" },
  { label: "Experience", href: "#experience" },
  { label: "Skills", href: "#skills" },
  { label: "Projects", href: "#projects" },
  { label: "Education", href: "#education" },
  { label: "Contact", href: "#contact" },
];
